import React, { useState, useEffect, useCallback } from 'react';
import { accountingAPI } from '../../../services/api';
import { AccountingList } from './AccountingList';
import { StatCard } from '../../../components/common/StatCard';
import { PageHeader } from '../../../components/layout/PageHeader';
import { TruckIcon } from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';

export function DeliveryChallansPage() {
  const [records, setRecords] = useState([]);
  const [pagination, setPg]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage]       = useState(1);
  const [search, setSearch]   = useState('');
  const [statusFilter, setSt] = useState('');
  const [totals, setTotals]   = useState({ count:0, total:0, dispatched:0, delivered:0 });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res  = await accountingAPI.getAll({ type: 'delivery_challan', status: statusFilter || undefined, page, limit: 15 });
      const data = res.data || [];
      setRecords(data);
      setPg(res.pagination);
      const dispatched = data.filter(r => r.status==='dispatched').length;
      const delivered  = data.filter(r => r.status==='delivered').length;
      setTotals({ count: res.pagination?.total||0, total: data.length, dispatched, delivered });
    } catch { toast.error('Failed to load'); }
    finally { setLoading(false); }
  }, [statusFilter, page]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-5">
      <PageHeader title="Delivery Challans" subtitle="Goods dispatch and delivery tracking documents" />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard title="Total"      value={loading?'...':totals.count}      icon={TruckIcon} color="blue"/>
        <StatCard title="This Page"  value={loading?'...':totals.total}      icon={TruckIcon} color="blue"/>
        <StatCard title="Dispatched" value={loading?'...':totals.dispatched}  icon={TruckIcon} color="amber"/>
        <StatCard title="Delivered"  value={loading?'...':totals.delivered}   icon={TruckIcon} color="green"/>
      </div>
      <AccountingList
        type="delivery_challan" title="Delivery Challans"
        records={records} loading={loading} pagination={pagination}
        onPageChange={setPage} onRefresh={load}
        search={search} setSearch={setSearch}
        statusFilter={statusFilter} setStatusFilter={setSt}
      />
    </div>
  );
}